var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeInvisibleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEEF0",
  d: "M10.914 13.406a2.406 2.406 0 0 0 2.397-2.615l-2.606 2.606q.103.01.209.01m7.965-9.849-.918-.917a.17.17 0 0 0-.243 0l-2.349 2.35q-1.943-.994-4.37-.994-6.193 0-9.242 6.452a1.3 1.3 0 0 0 0 1.106q1.218 2.566 2.934 4.114L2.418 17.94a.17.17 0 0 0 0 .243l.917.917a.17.17 0 0 0 .243 0l15.3-15.3a.17.17 0 0 0 .038-.187.2.2 0 0 0-.037-.056M7.133 11a3.78 3.78 0 0 1 5.562-3.336L11.65 8.709a2.408 2.408 0 0 0-3.028 3.027l-1.044 1.045A3.76 3.76 0 0 1 7.133 11"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEEF0",
  d: "M20.243 10.446q-1.136-2.389-2.7-3.896l-3.098 3.097a3.783 3.783 0 0 1-4.884 4.885l-2.627 2.626q1.828.846 4.066.846 6.194 0 9.243-6.452a1.3 1.3 0 0 0 0-1.106"
})));
export { SvgEyeInvisibleFilled as ReactComponent };
export default __webpack_public_path__ + "static/media/eyeInvisibleFilled.63f2781e.svg";